import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Services } from "../components/Services";
import { HowItWorks } from "../components/HowItWorks";
import { About } from "../components/About";
import { Testimonials } from "../components/Testimonials";
import { FAQ } from "../components/FAQ";
import { LeadForm } from "../components/LeadForm";
import { Footer } from "../components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-brand-cream">
      <Header />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <About />
        <Testimonials />
        <LeadForm />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
